import type { ResetPasswordException } from "@freightsimple/generated-dashboard-openapi-client/models/ResetPasswordException";

export class ResetPasswordError extends Error {
  data: ResetPasswordException;
  constructor(data: ResetPasswordException) {
    super(JSON.stringify(data));
    this.data = data;
    this.name = "ResetPasswordError";
  }
}
